// extracted by mini-css-extract-plugin
export var actions = "_j2-g";
export var benefitCard = "_j2-b";
export var benefitIcon = "_j2-d";
export var benefitLabel = "_j2-f";
export var benefits = "_j2-a";
export var benefitsSection = "_j2-8";
export var bodyText = "_j2-7";
export var closeButton = "_j2-2";
export var content = "_j2-3";
export var eyebrow = "_j2-4";
export var heading = "_j2-5";
export var image = "_j2-i";
export var imagePanel = "_j2-h";
export var modal = "_j2-0";
export var offerCard = "_j2-c";
export var offerIcon = "_j2-e";
export var sectionLabel = "_j2-9";
export var shell = "_j2-1";
export var title = "_j2-6";